import React from 'react';

interface CampaignPromoBannerContentProps {
    title: React.ReactNode;
    description: React.ReactNode;
}

export const CampaignPromoBannerContent: React.FC<CampaignPromoBannerContentProps> = ({ title, description }) => (
    <div className="lg:min-w-0 lg:flex-1">
        <div className="text-[2rem] leading-[1.25] font-bold text-brand-secondary lg:text-[1.8rem]">{title}</div>
        <div className="mt-[0.8rem] text-[1.5rem] leading-[1.4] text-neutral-gray lg:text-[1.4rem] lg:leading-[1.35]">
            {description}
        </div>
    </div>
);
